const SessionChatLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M12.9999 15L12.9999 19H15.9998V21H7.9999V19H10.9999V15H3.99993C3.73472 15 3.48036 14.8946 3.29283 14.7071C3.10529 14.5196 2.99994 14.2652 2.99994 14L2.99994 4C2.99994 3.73478 3.10529 3.48043 3.29283 3.29289C3.48036 3.10536 3.73472 3 3.99993 3L19.9998 3C20.265 3 20.5194 3.10536 20.7069 3.29289C20.8944 3.48043 20.9998 3.73478 20.9998 4V14C20.9998 14.2652 20.8944 14.5196 20.7069 14.7071C20.5194 14.8946 20.265 15 19.9998 15H12.9999ZM4.99992 13H18.9998V5L4.99992 5L4.99992 13ZM7.9999 8L15.9998 8V10H7.9999L7.9999 8Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default SessionChatLine;
